<template>
    <b-container fluid class="mt--7">
        <ViewItem
            v-if="!!template"
            :item="template"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="template = null"
            @error="alertError"
        ></ViewItem>

        <ListItems
            v-else
            title="Templates"
            @show-item="showTemplate"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button size="sm" variant="primary" @click="template = {}"
                        >Add Template</b-button
                    >
                </b-col>
            </b-row>
        </ListItems>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'OrderTemplate',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins,permissionsMixins,errorHandlingMixins],
    data: () => {
        return {
            componentName:'Review Template',
            template: null,
        }
    },
    created() {
        this.$store.dispatch('checkoffTypes/fetchAll')
        this.$store.dispatch('checkoffTemplates/fetchAll')
    },

    computed: {
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        showTemplate(id) {
            this.template = this.templates.find(x => x.id === id)
        },

        alertSuccess(action) {
            //const message= isUpdated? 'Review template updated successfully' : 'Review template created successfully'
            //const action= isUpdated? 'Updated':'Created'

            this.genericToast(this.componentName, (action.charAt(0).toUpperCase() + action.slice(1)+'d' ),'success', `${this.componentName} ${action.toLowerCase(   )}d successfully`)
            //this.doToast('Success', message, 'success')
            this.template = null
        },

        alertError(error,name){
            let message = error.message
            console.log('mmm', message)
            const interror = 'Internal Server Error'
            if (interror == error.message) {

            this.genericToast(`${this.componentName}`,'Duplicate','danger',`"${name}" is already in use. Please choose a different name`)

            }
        }
    },
}
</script>
<style></style>
